import React from 'react';
import { useEffect, useState } from 'react';
import { pageView, customEvent } from '../../Utilities/GoogleAnalytics';
import TopBar from '../../Components/TopBar';
import Footer from '../../Components/Footer';
import axios from 'axios';

export default function AffiliateApply() {
  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
  }, []);

  const [name, setName] = useState('');
  const [familyname, setFamilyName] = useState('');
  const [gumroadID, setGumroadID] = useState('noemail@stamped.wiki');
  const [email, setEmail] = useState('');
  const [instagramURL, setinstagramURL] = useState('');
  const [youtubeURL, setyoutubeURL] = useState('');
  const [twitterURL, settwitterURL] = useState('');
  const [applied, setApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const breadcrumbs = [
    {
      name: 'Home',
      url: '/',
      active: false,
    },
    {
      name: 'Affiliates',
      url: '/affiliate',
      active: false,
    },
    {
      name: 'Application',
      url: '/affiliate/apply',
      active: true,
    },
  ];

  function handleSubmit(e) {
    e.preventDefault();

    /** Validations to be added */
    // customEvent('AFFILIATE', 'Submitted');
    if (!loading) {
      setLoading(true);
      setError(false);
      const data = { name, familyname, gumroadID, email, instagramURL, youtubeURL, twitterURL };
      axios.post(`https://stamped-cms.herokuapp.com/affiliates`, data).then((res) => {
        if (res.data.message === 'Success') {
          //do something happy
          setApplied(true);
          setLoading(false);
        } else {
          //do something sad
          setError(true);
        }
      });
    }
  }

  const Applied = () => (
    <div className="px-3 pt-3">
      {' '}
      <h1 className="text-2xl font-bold text-brandcolor font-brand"> Successfully applied for Stamped Parner Program! </h1>
      <p className="my-2 text-sm antialiased">
        {' '}
        We process all our requests within 7 working days! If you haven't heard from us by that time, write a mail on support@stamped.wiki and our
        representative will get in touch with you.
      </p>
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <TopBar affiliatePage />
      <>
        <div className="max-w-3xl min-h-screen px-3 pt-24 m-auto mb-32 lg:pt-32 ">
          <p className="my-5 text-xs text-gray-600">
            {breadcrumbs.map((crumb, i) => (
              <a href={crumb.url}>
                <span className={`${crumb.active ? 'text-black font-semibold' : ''}`}>
                  {crumb.name} {breadcrumbs[i + 1] ? '/' : ''}{' '}
                </span>
              </a>
            ))}
          </p>
          <hr className="my-5 opacity-25" />
          {error ? (
            <div className="flex items-center justify-center w-full px-10 py-3 my-4 space-x-3 text-sm text-white bg-brandcolor">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <p> Due to a technical error, we are not able to process the request. Send us a mail on support@stamped.wiki </p>
            </div>
          ) : (
            ''
          )}
          {applied ? (
            <Applied />
          ) : (
            <div id={'affiliate-section'}>
              <h1 className="text-2xl font-bold text-brandcolor font-brand"> Apply for the affiliate program </h1>
              <p className="my-2 text-sm antialiased">
                {' '}
                Please complete the inputs below. Stamped will review your application based on your subscribers, followers and content.
              </p>
              <form onSubmit={(e) => handleSubmit(e)} className="my-6" id={'form'}>
                <div className="flex my-3 space-x-5">
                  <input
                    required
                    type="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="First Name"
                  />
                  <input
                    type="surname"
                    required
                    value={familyname}
                    onChange={(e) => setFamilyName(e.target.value)}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="Family Name"
                  />
                </div>
                {/* <div className="flex my-3 space-x-5">
                  <input
                    type="email"
                    required
                    value={gumroadID}
                    onChange={(e) => setGumroadID(e.target.value)}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="Your Gumroad Email Address"
                  />
                  <p className="w-full px-2 py-2 text-xs font-normal placeholder-gray-800 border border-black md:px-4">
                    {' '}
                    Gumroad is a payment provider that transfers amount directly in your account.{' '}
                    <span className="font-bold text-mapBlack">Create your account with Gumroad here.</span>{' '}
                  </p>
                </div> */}
                <div className="flex my-3 space-x-5">
                  <input
                    type="email"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="Email Address"
                  />
                  <input
                    type="text"
                    value={instagramURL}
                    onChange={(e) => setinstagramURL(e.target.value)}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="Instagram Handle (Optional)"
                  />
                </div>
                <div className="flex my-3 space-x-5">
                  <input
                    type="text"
                    value={youtubeURL}
                    onChange={(e) => setyoutubeURL(e.target.value)}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="YouTube Channel Link (Optional)"
                  />
                  <input
                    value={twitterURL}
                    type="text"
                    onChange={(e) => settwitterURL(e.target.value)}
                    className="w-full px-2 py-2 text-xs font-semibold placeholder-gray-800 transition-all duration-200 border-black border-opacity-25 outline-none md:px-4 ring-offset-4 bg-darkAlt focus:ring-2 focus:ring-darkAlt"
                    placeholder="Twitter Handle (Optional)"
                  />
                </div>
                <div className="flex my-12 space-x-4">
                  <button
                    type={`${loading ? 'none' : 'submit'}`}
                    className={`w-full px-2 py-2 text-sm font-semibold text-white md:px-4 bg-brandcolor lg:w-full ${loading ? 'bg-gray-400' : ''}`}
                  >
                    {' '}
                    {loading ? 'Loading, please wait.' : 'Submit Your Application'}
                  </button>
                </div>
              </form>
              <div className="w-full bg-altBack">
                <p className="px-2 py-2 text-xs text-gray-700">
                  {' '}
                  ⚠️ Please note we are open to only a limited number of registrations. You may submit your application to enter the waitlist. Your
                  application might be selected based on a number your factors such as metrics and content. You must have atleast one social profile
                  for your application to be considered complete.{' '}
                </p>
              </div>
            </div>
          )}
        </div>
      </>
      <Footer />
    </div>
  );
}
